// extracted by css-extract-rspack-plugin
var _1 = "Q0K3G";
var _2 = "FLwLv";
export { _1 as "icon", _2 as "root" }
